import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./PromptNavigator.css";

export default function PromptNavigator() {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const commands = [
    { name: "Dashboard", route: "/dashboard" },
    { name: "Inventory", route: "/inventory" },
    { name: "Products", route: "/products" },
    { name: "Warehouses", route: "/warehouse" },
    { name: "Add Warehouse", route: "/warehouse?add=true" }, 
    { name: "Orders", route: "/orders" },
    { name: "Reports", route: "/reports" },
    { name: "Users", route: "/users" },
  ];
  

  // filter commands based on input
  const filteredCommands = commands.filter(cmd =>
    cmd.name.toLowerCase().includes(query.toLowerCase())
  );


  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ctrl + q (or Cmd + q on Mac) to open commad prompt modal
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "q") {
        e.preventDefault();
        setIsOpen(prev => !prev);
      }
      // press escape to close the prompt modal
      if (e.key === "Escape") setIsOpen(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleSelect = (route) => {
    // If route has ? or #, append a unique timestamp
    if (route.includes("?") || route.includes("#")) {
      navigate(`${route}&_=${Date.now()}`);
    } else {
      navigate(`${route}?_=${Date.now()}`);
    }

    setIsOpen(false);
    setQuery("");
  };

  if (!isOpen) return null;

  return (
    <div className="prompt-overlay" onClick={() => setIsOpen(false)}>
      <div className="prompt-box" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus
          type="text"
          placeholder="Type a command..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && filteredCommands.length > 0) {
              handleSelect(filteredCommands[0].route);
            }
          }}
        />
        <ul className="prompt-list">
          {filteredCommands.length > 0 ? (
            filteredCommands.map(cmd => (
              <li key={cmd.route} onClick={() => handleSelect(cmd.route)}>
                {cmd.name}
              </li>
            ))
          ) : (
            <li className="no-results">No results</li>
          )}
        </ul>
      </div>
    </div>
  );
}
